import CustomerAcquisition from "assets/images/partnerships-banners/customer-acquisition.svg";
import RevenueGrowth from "assets/images/partnerships-banners/revenue-growth.svg";
import BrandLoyalty from "assets/images/partnerships-banners/brand-loyalty.svg";

export const BENEFITS_LIST = [
  {
    title: "Customer Acquisition",
    text: "Drive foot traffic in store and online with highly targeted incentives.",
    icon: CustomerAcquisition
  },
  {
    title: "Revenue Growth",
    text: "Boost basket size and average order value with consumer overspend.",
    icon: RevenueGrowth
  },
  {
    title: "Brand Loyalty",
    text: "Increase purchase frequency of your best customers.",
    icon: BrandLoyalty
  }
];
